import { Aggregation } from 'store/productivityRate.store';

export const aggregationOptions: ISelectOption<Aggregation>[] = [
    { label: 'Average', value: 'AVERAGE' },
    { label: 'P50 (Median)', value: 'P50' },
    { label: 'P80 (High)', value: 'P80' },
];
